import { Component, Input, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'app/shared/models/subject';
import { Referral } from 'app/shared/models/referral';
import { RafReportObject } from 'app/shared/models/report-objects';
import { TranslationService, Language } from 'app/shared/services/translation.service';

@Component({
  selector: 'raf-report-widget',
  templateUrl: './raf-report-widget.component.html',
  styleUrls: ['./raf-report-widget.component.scss'],
  animations: fuseAnimations,
})

export class RafReportWidgetComponent implements OnInit {

  reportDetails?: any;
  @Input() jsonData: any;
  @Input() language: Language;
  @Input() showTranslation: boolean;
  rafReportObject: RafReportObject;

  constructor(public translationService: TranslationService) { }

  ngOnInit(): void {    
    if (this.jsonData) {
      this.reportDetails = this.jsonData;
      this.rafReportObject = this.reportDetails as RafReportObject;
    }
  }

}